import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSection } from '../../actions/main.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updateTestimonials } from '../../slices/main-content.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const TestimonialsPage = () => {
  const dispatch = useAppDispatch();

  const { testimonials } = useAppSelector(({ main }) => main.sections);

  const handleUpdateTestimonialsContent = (key: string, value: string) => {
    dispatch(updateTestimonials({ ...testimonials, [key]: value }));
  };

  const handleSaveBanner = () => {
    dispatch(updateSection({ section: testimonials }));
  };

  return (
    <ContainerTemplate>
      <Card title="Отзывы контент" className={'border-2 border-yellow'}>
        <div>
          <label htmlFor="headline">Заголовок</label>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={testimonials.title ?? ''}
            onChange={({ target }) => handleUpdateTestimonialsContent('title', target.value)}
          />
        </div>
        <div className="mt-2">
          <label htmlFor="Subtitle">Подзаголовок</label>
          <InputTextarea
            className={'w-full'}
            id="subtitle"
            value={testimonials.subtitle ?? ''}
            onChange={({ target }) => handleUpdateTestimonialsContent('subtitle', target.value)}
          />
        </div>
        <Button
          label="Сохранить"
          icon="pi pi-check"
          className={'mt-2'}
          onClick={handleSaveBanner}
        />
      </Card>
    </ContainerTemplate>
  );
};
